import React from 'react';

function BlockchainLockIcon({ size = 18 }) {
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, flexShrink: 0 }}>
      {/* Chain links — blockchain symbol */}
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Left link */}
        <rect x="2" y="8" width="8" height="5" rx="2.5" stroke="currentColor" strokeWidth="2" fill="none"/>
        {/* Right link */}
        <rect x="14" y="8" width="8" height="5" rx="2.5" stroke="currentColor" strokeWidth="2" fill="none"/>
        {/* Connector */}
        <line x1="10" y1="10.5" x2="14" y2="10.5" stroke="currentColor" strokeWidth="2"/>
      </svg>

      {/* Yellow lock badge — bottom right */}
      <svg
        width={size * 0.52}
        height={size * 0.52}
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          bottom: -2,
          right: -3,
          filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.6))',
        }}
      >
        {/* Badge circle */}
        <circle cx="7" cy="7" r="6.5" fill="#1a0533" stroke="#f59e0b" strokeWidth="1"/>
        {/* Lock shackle */}
        <path d="M5 6V5a2 2 0 1 1 4 0v1" stroke="#f59e0b" strokeWidth="1.1" strokeLinecap="round" fill="none"/>
        {/* Lock body */}
        <rect x="4" y="6" width="6" height="4.5" rx="1" fill="#f59e0b"/>
        {/* Keyhole */}
        <circle cx="7" cy="8" r="0.9" fill="#1a0533"/>
      </svg>
    </span>
  );
}

export default BlockchainLockIcon;
